import React from 'react';
import {
  Eye, FileText, Globe, MousePointerClick, Search, TrendingUp,
} from 'lucide-react';
import { KpiCard, LoadingSkeleton } from './_shared';
import IndexNowActivityCard from './IndexNowActivityCard';
import SearchAnalyticsCard from './SearchAnalyticsCard';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function SeoTab({ data }) {
  if (!data) return <LoadingSkeleton />;
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KpiCard icon={MousePointerClick} label="Total Clicks" value={data.total_clicks?.toLocaleString()} color="#10B981" />
        <KpiCard icon={Eye} label="Total Impressions" value={data.total_impressions?.toLocaleString()} color="#3B82F6" />
        <KpiCard icon={TrendingUp} label="Avg Position" value={data.avg_position} color="#F59E0B" />
        <KpiCard icon={FileText} label="Indexed Pages" value={data.total_pages} color="#8B5CF6" />
      </div>
      <SearchAnalyticsCard />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl border border-gray-100 p-6">
          <h3 className="text-sm font-semibold text-gray-900 flex items-center gap-2 mb-4">
            <Search className="w-4 h-4 text-green-500" /> Top Search Queries
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-gray-400 text-xs border-b border-gray-100">
                <th className="pb-2 font-medium">Query</th><th className="pb-2 font-medium text-right">Clicks</th><th className="pb-2 font-medium text-right">Impr.</th><th className="pb-2 font-medium text-right">Pos.</th>
              </tr></thead>
              <tbody>
                {(data.queries || []).slice(0, 20).map((q, i) => (
                  <tr key={q.query} className="border-b border-gray-50 last:border-0">
                    <td className="py-2 text-gray-700 truncate max-w-[200px]">{q.query}</td>
                    <td className="py-2 text-right font-mono text-gray-500">{q.clicks}</td>
                    <td className="py-2 text-right font-mono text-gray-400">{q.impressions?.toLocaleString()}</td>
                    <td className="py-2 text-right font-mono text-gray-400">{q.position?.toFixed(1)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="bg-white rounded-xl border border-gray-100 p-6">
          <h3 className="text-sm font-semibold text-gray-900 flex items-center gap-2 mb-4">
            <Globe className="w-4 h-4 text-blue-500" /> Top Pages by Clicks
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-gray-400 text-xs border-b border-gray-100">
                <th className="pb-2 font-medium">Page</th><th className="pb-2 font-medium text-right">Clicks</th><th className="pb-2 font-medium text-right">CTR</th>
              </tr></thead>
              <tbody>
                {(data.pages || []).slice(0, 20).map((p, i) => (
                  <tr key={p.page} className="border-b border-gray-50 last:border-0">
                    <td className="py-2 text-gray-700 truncate max-w-[250px]" title={p.page}>{p.page.replace('https://ninjathlete.com', '')}</td>
                    <td className="py-2 text-right font-mono text-gray-500">{p.clicks}</td>
                    <td className="py-2 text-right font-mono text-gray-400">{p.ctr}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <IndexNowActivityCard />
    </div>
  );
}
